export class TenantFilter {
  page: number = 1;
  size: number = 5;
}
